// Shared query/caching layer built on @tanstack/query-core, with an RxJS adapter for Angular 14.
// It has no dependencies on this app, so it can move into a shared package for the manager app.
// Once the apps are on Angular 16+, it can be swapped for @tanstack/angular-query; query keys and
// options carry over unchanged.
export { QueryModule, createQueryClient } from './query-client';
export { InvalidateOnWriteInterceptor, SKIP_QUERY_INVALIDATION } from './invalidate-on-write.interceptor';
export { query$, fromObservable } from './query';
export type { QueryOptions, QueryResult } from './query';
export { QueryClient, hashKey, keepPreviousData } from '@tanstack/query-core';
export type { QueryKey, QueryObserverResult } from '@tanstack/query-core';
